import { useDispatch, useSelector } from "react-redux";
import { slices } from "../redux";

export const useGrowthAverageType = () => {
    const dispatch = useDispatch();
    const type = useSelector((state) => state.growthAverageType);

    return [type, (type) => dispatch(slices.growthAverageType.actions.setType(type))];
};
